<template>
  <div class="screeners-filters">
    <v-spacer/>
    <v-select
      :value="status"
      :items="statuses"
      class="bh-input-pill rounded-pill"
      color="accent"
      height="48px"
      filled
      clearable
      :disabled="loading"
      placeholder="Status"
      dense
      hide-details
      @input="onInput('status', $event)"
    ></v-select>
    <v-select
      :value="type"
      :items="types"
      :disabled="loading"
      class="bh-input-pill rounded-pill"
      color="accent"
      height="48px"
      clearable
      filled
      placeholder="Type"
      dense
      hide-details
      @input="onInput('type', $event)"
    ></v-select>
  </div>
</template>
<script>
import { debounce } from "@/helpers/debounce"
export default {
  name: "ScreenersFilters",
  components: {},
  data: () => ({
    statuses: [ 
      { text: 'New', value: 'NEW' },
      { text: 'Opened', value: 'OPENED' },
      { text: 'Completed', value: 'COMPLETED' },
    ],
    types: [ 
      { text: 'Public', value: 'PUBLIC' },
      { text: 'Private', value: 'PRIVATE' },
    ],
  }),
  props: [ 'status', 'type', 'loading' ],
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    onInput (key, value) {
      console.log(key,value)
      this.tmpValue = value
      this.$emit('search-on:input', { key, value })
    }
  }
};
</script>
<style lang="scss">
.screeners-filters {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}
.bh-input-pill {
  margin: 0 8px !important;
  width: 264px;
  height: 48px !important;

  &.v-select {
    width: 120px;
  }

  .v-select__slot,
  .v-input__slot {
    align-items: center;
    height: 48px;
    min-height: 0 !important;

    &::before,
    &::after {
      content: "";
      display: none;
    }

    .v-input__append-inner {
      align-self: center;
      margin-top: 0 !important;
    }

    .v-icon {
      color: $bh-blue;
    }
  }
}
</style>
